export const DANHMUC_SET_LIST_DATA = 'DANHMUC_SET_LIST_DATA';
export const DANHMUC_SET_LIST_META = 'DANHMUC_SET_LIST_META';
export const DANHMUC_TITLE = 'Danh Mục';